module.exports = __webpack_public_path__ + "img/img27.e719c16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img27.jpg
// module id = 293
// module chunks = 0